import Select from "components/form/Select/Select";
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import useData from "hooks/useData";
import Loader from "components/ui/Loader/Loader";
import Alert from "components/ui/Alert/Alert";

const BulletinTypes = ({ defaultValue, onChange, categoryParentId = null }) => {
  const [ loading, setLoading ] = useState(true);
  const [ selected, setSelected ] = useState(defaultValue);
  const { getData } = useData();
  const types = useRef();

  useEffect(
    () => {
      const load = async () => {
        setLoading(true);
        const { data } = await getData('rest/bulletin-types', { parent_id: categoryParentId });
        types.current = data;
        setLoading(false);
      }
      if (!types.current) {
        load();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  if (loading) {
    return <Loader containerVariant={ 'center' }/>;
  }

  if (!types.current) {
    return <Alert message={ `De categorieën konden niet worden opgehaald. Ververs de pagina en probeer het opnieuw.` }/>
  }

  const handleChange = (value) => {
    setSelected(value);
    onChange(value);
  }

  const items = types.current.map((item) => {
    return {
      id: item.tid[0].value,
      value: item.name[0].value,
    }
  });

  return (
    <Select name={ `bulletin-types` } onChange={ handleChange } value={ selected } items={ items } addEmptyOption/>
  )
}

BulletinTypes.propTypes = {
  defaultValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  categoryParentId: PropTypes.number,
}

export default BulletinTypes;
